import { prefixerM } from './common'

export const ROUTE_PPG_ORDENPEDIDO = prefixerM('orden-pedido')
export const ROUTE_PPG_SOLICITUDCAMBIOOP = prefixerM('solicitud-cambio-op')
export const ROUTE_PPG_ORDENTRABAJO = prefixerM('orden-trabajo')
export const ROUTE_PPG_BANDEJAORDENTRABAJO = prefixerM('bandeja-orden-trabajo')
export const ROUTE_PPG_APROBACIONPRODUCTO = prefixerM('aprobacion-producto')
export const ROUTE_PPG_APROBACIONOP = prefixerM('aprobacion-op')
export const ROUTE_PPG_COSTOS = prefixerM('costos')
export const ROUTE_PPG_APROBACIONOPSINANTICIPO = prefixerM('aprobacion-op-sin-anticipo')
